import React from 'react';
import { Form } from 'react-form';
import { Input, Select } from '../../Form';
import { required } from '../../../utils/validation';
import Popup from '../../Popup';
import { getRedshirtClassYearOptions, CLASS_YEAR_IDS } from '../../../utils/constants';
import styles from './confirmRedshirtStatusPopUp.scss';

const ConfirmRedshirtStatusPopUp = props => {
    const {
        onCloseClick,
        onCtaClick,
        playerId,
        defaultClassYearId = CLASS_YEAR_IDS.FRESHMAN, // Default to Freshman if not provided
    } = props;
    const defaultValues = {
        playerId,
        classYearId: defaultClassYearId,
    };

    const classYearOptions = getRedshirtClassYearOptions();

    return (
        <Popup
            className="popup-md"
            popUpClassName={styles.popupConfig}
            onCloseClick={onCloseClick}
            config={{
                fullScreen: false,
                noPadding: true,
                gradient: true,
                scrollable: false,
                noHeader: true,
            }}
        >
            <div className={styles.popupContainer}>
                <p className={styles.popupHeader}>
                    Confirm Redshirt Status
                </p>
                <p className={styles.popupDetails}>
                    Setting a player as a redshirt will preserve a year of their athletic eligibility. Please select their designated class year for this season.
                </p>
                <Form
                    key={`confirmRedshirtStatusForm-${defaultClassYearId}`}
                    onSubmit={values => onCtaClick(values)}
                    id="confirmRedshirtStatusForm"
                    defaultValues={defaultValues}
                >
                    {({ submitForm }) => {
                        return (
                            <form onSubmit={submitForm} id="confirmRedshirtStatusForm">
                                <Input id="playerId" field={'playerId'} value={`${playerId}`} type="hidden" />
                                <div className={styles.confirmRedshirtInputContainer}>
                                    <Select
                                        id="classYearId"
                                        label="Designated Class Year"
                                        field="classYearId"
                                        emptyOption="Please select a class year"
                                        options={classYearOptions}
                                        validate={required}
                                    />
                                </div>
                                <div className={styles.buttonContainer}>
                                    <div className={styles.buttonWrapper}>
                                        <button
                                            onClick={onCloseClick}
                                            type="button"
                                            className={`btn btn-default text-uppercase btn-block ${styles.cancelButton}`}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div className={styles.buttonWrapper}>
                                        <button
                                            type="submit"
                                            className={`btn btn-primary text-uppercase btn-block ${styles.submitButton}`}
                                        >
                                            Confirm
                                        </button>
                                    </div>
                                </div>
                            </form>
                        );
                    }}
                </Form>
            </div>
        </Popup>
    );
};

export default ConfirmRedshirtStatusPopUp;
